import { Link } from 'react-router-dom';
import Footer from '../home/components/Footer';

const LOGO_URL =
  'https://static.readdy.ai/image/9ce25d869b896a3f5b856271bcc15d01/04593552a0ea563d300a18e4891c8936.jpeg';

const COOKIE_TYPES = [
  {
    name: 'Hädavajalikud küpsised',
    desc: 'Need küpsised on vajalikud veebilehe põhifunktsioonide toimimiseks. Neid ei saa keelata.',
    examples: 'Seansiküpsised, CSRF-kaitse',
    required: true,
  },
  {
    name: 'Analüütilised küpsised',
    desc: 'Aitavad meil mõista, kuidas külastajad veebilehte kasutavad, et saaksime seda parandada.',
    examples: 'Google Analytics (_ga, _gid)',
    required: false,
  },
  {
    name: 'Eelistuste küpsised',
    desc: 'Salvestavad teie eelistusi, nagu keelevalik, et veebileht oleks teile mugavam.',
    examples: 'Keelesätted, nõustumise olek',
    required: false,
  },
];

export default function KupsistPoliitika() {
  return (
    <div className="min-h-screen bg-white flex flex-col font-sans">
      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center h-12 w-auto">
            <img src={LOGO_URL} alt="IISRAL Recycling OÜ" className="h-12 w-auto object-contain" />
          </Link>
          <Link
            to="/"
            className="flex items-center gap-2 text-sm font-medium text-gray-500 hover:text-eco-green transition-colors cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-left-line" />
            </div>
            Tagasi avalehele
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-8 py-16">
          {/* Page title */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-6 h-0.5 bg-eco-green" />
              <span className="text-eco-green text-xs font-bold uppercase tracking-widest">Juriidiline teave</span>
            </div>
            <h1 className="text-4xl font-extrabold text-gray-900 mb-4">Küpsiste poliitika</h1>
            <p className="text-sm text-gray-400">Viimati uuendatud: 20. märts 2026</p>
          </div>

          <div className="space-y-10 text-gray-600 text-sm leading-relaxed">

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">1. Mis on küpsised?</h2>
              <p>
                Küpsised (inglise keeles <em>cookies</em>) on väikesed tekstifailid, mida veebileht salvestab
                teie seadmesse. Need aitavad veebilehel meeles pidada teie eelistusi ja parandada
                kasutajakogemust.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">2. Milliseid küpsiseid kasutame</h2>
              <div className="space-y-4 mt-4">
                {COOKIE_TYPES.map((type) => (
                  <div
                    key={type.name}
                    className="border border-gray-100 rounded-lg p-5 bg-[#F9FBF7]"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-bold text-gray-800 text-sm">{type.name}</h3>
                      {type.required ? (
                        <span className="text-xs font-semibold text-eco-green bg-pale-green px-2.5 py-1 rounded-full">
                          Kohustuslik
                        </span>
                      ) : (
                        <span className="text-xs font-semibold text-gray-400 bg-gray-100 px-2.5 py-1 rounded-full">
                          Valikuline
                        </span>
                      )}
                    </div>
                    <p className="text-gray-500 text-sm mb-2">{type.desc}</p>
                    <p className="text-xs text-gray-400">
                      <span className="font-medium text-gray-500">Näited:</span> {type.examples}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">3. Küpsiste haldamine</h2>
              <p className="mb-3">
                Saate küpsiseid hallata oma brauseri seadetes. Enamik brausereid võimaldab:
              </p>
              <ul className="list-disc list-inside space-y-1.5 ml-2">
                <li>Vaadata ja kustutada salvestatud küpsiseid</li>
                <li>Blokeerida küpsiseid teatud veebilehtedelt</li>
                <li>Keelata kolmandate osapoolte küpsised</li>
              </ul>
              <p className="mt-3 text-gray-500">
                Pange tähele, et teatud küpsiste keelamine võib mõjutada veebilehe toimimist.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">4. Nõusolek</h2>
              <p>
                Veebilehele sisenedes küsime teie nõusolekut mittehädavajalike küpsiste kasutamiseks.
                Võite igal ajal oma nõusoleku tagasi võtta, kustutades brauserist küpsised.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">5. Muudatused</h2>
              <p>
                Jätame endale õiguse käesolevat poliitikat ajakohastada. Muudatustest teavitame
                veebilehel.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-gray-800 mb-3">6. Kontakt</h2>
              <p>
                Küsimuste korral kirjutage:{' '}
                <a
                  href="mailto:recycling@iisral.eu"
                  className="text-eco-green hover:underline font-medium"
                >
                  recycling@iisral.eu
                </a>
              </p>
            </section>

          </div>

          {/* Back link */}
          <div className="mt-14 pt-8 border-t border-gray-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-eco-green text-white text-sm font-bold px-6 py-3 rounded-full cursor-pointer whitespace-nowrap hover:bg-dark-green transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line" />
              </div>
              Tagasi avalehele
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
